import { defineComponent as r, openBlock as n, createBlock as c, unref as p, mergeProps as l, withCtx as s, createElementVNode as e } from "vue";
import { RevIcon as f } from "@ds/components/Icon";
const m = /* @__PURE__ */ r({
  name: "IconReassuranceTrustedShops",
  __name: "IconReassuranceTrustedShops",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (d, a) => (n(), c(p(f), l(o, { "view-box": "0 0 48 48" }), {
      default: s(() => [...a[0] || (a[0] = [
        e("g", {
          "fill-rule": "evenodd",
          "clip-path": "url(#4a038286-f894-4f00-9394-9603af0f84bca)",
          "clip-rule": "evenodd"
        }, [
          e("path", { d: "M14.43 27.83c0-7.06 5.21-14 12.51-14 2.46 0 5.77 1.02 5.81 3.94 0 5.026-7.422 6.933-11.73 8.041l-.77.2a18 18 0 0 0-.3 2.67c0 1.89 1 3.55 3 3.55 2.67 0 4.84-2.54 6.36-4.42l1.24.87c-2.23 3.25-5.27 6.15-9.32 6.15-4.33 0-6.8-2.65-6.8-7M26.5 15.26c-3.41 0-5.21 6.66-5.85 9.26 3.15-.95 7.57-3.62 7.57-7.26a1.73 1.73 0 0 0-1.72-2" }),
          e("path", { d: "M10.666 4.045a24 24 0 1 1 26.668 39.91 24 24 0 0 1-26.668-39.91m5 32.427A15 15 0 0 0 24 39a14.95 14.95 0 0 0 15-15 15 15 0 1 0-23.333 12.472" })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "4a038286-f894-4f00-9394-9603af0f84bca" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  m as default
};
